<template>
  <el-form
    ref="formRef"
    require-asterisk-position="right"
    label-position="top"
    :model="formValues"
    :rules="rules"
  >
    <div style="display: flex">
      <div class="oa-form-left">
        <el-form-item prop="bankAccountNumber" label="银行卡号">
          <el-input
            v-model="formValues.bankAccountNumber"
            clearable
            autocomplete="nony"
            placeholder="请输入"
            @keyup.enter="onKeyupEnter"
          />
        </el-form-item>
        <el-form-item prop="bankReservedPhone" label="银行卡预留手机号">
          <el-input
            v-model="formValues.bankReservedPhone"
            clearable
            autocomplete="nony"
            placeholder="请输入"
            @keyup.enter="onKeyupEnter"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script setup lang="ts">
import { FormInstance, FormRules } from 'element-plus';
import { computed, PropType, ref, watch } from 'vue';
import { checkPhone, scrollToErrorField } from '@core/tools';
import { IPersonalInfo } from '@core/main';

const props = defineProps({
  data: {
    type: Object as PropType<IPersonalInfo>,
    default: () => {
      return {} as IPersonalInfo;
    },
  },
  enableEnterKey: {
    type: Boolean,
    default: true,
  },
  autoScrollToError: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{'key-enter': []}>();

const formRef = ref<FormInstance>();

const formValues = ref({} as IPersonalInfo);

const rules = computed<FormRules<IPersonalInfo>>(() => {
  return {
    bankAccountNumber: [
      {
        required: true,
        message: '请输入银行卡号',
      },
    ],
    bankReservedPhone: [
      {
        required: true,
        validator: (rule: any, value: string, callback: any) => {
          if (checkPhone(formValues.value.bankReservedPhone, '银行预留')) {
            callback(checkPhone(formValues.value.bankReservedPhone, '银行预留'));
          }
          callback();
        },
      },
    ],
  };
});

async function validate(callback?: () => void) {
  let valid = false;

  if (!formRef.value) return valid;

  await formRef.value.validate((v) => {
    if (v) {
      valid = true;
      callback && callback();
    } else {
      if (props.autoScrollToError) scrollToErrorField(formRef.value.$el);
    }
  });

  return valid;
}

async function onKeyupEnter() {
  if (!props.enableEnterKey) return;

  const valid = await validate();

  if (!valid) return;

  if (!valid) {
    if (props.autoScrollToError) scrollToErrorField(formRef.value.$el);
    return;
  }

  emit('key-enter');
}

function resetFormValues() {
  const d = JSON.parse(JSON.stringify(props.data)) as IPersonalInfo;

  formRef.value?.resetFields?.();
  formValues.value = {
    bankAccountNumber: d.bankAccountNumber,
    bankReservedPhone: d.bankReservedPhone,
  };
}

watch(
  () => props.data,
  () => {
    resetFormValues();
  },
  { immediate: true },
);

defineExpose({
  /**
   * 信息校验
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 获取表单数据 */
  getValues: () => formValues.value,
  /** 表单数据重置（base props.data） */
  reset: resetFormValues,
});
</script>

<style scoped lang="scss" src="@core/main/src/components/open-account/index.scss" />

